function TextLink(data) {
    return (
        <a 
            className="has-link-icon" 
            href={data.href}
            alt={data.children}
            target="_blank"
            rel="noreferrer"
        >
            {data.children}
            <span className="line"></span>
        </a>
    )
}

export default TextLink;